import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Prop, Mixins } from "vue-property-decorator";
import simplebar from "simplebar-vue";
// SYSTEM1
import Loader from "@/components/widgets/loader.vue";
import BaseMixer from "@/router/views/BaseMixer";
import QuestionAndAnswerComponent from "./QuestionAndAnswerComponent.vue";
import { IPAReviewFormDetailItemDTO } from "@/store/models/paReview/paReviewFormDetailItemDTO";
let ReviewFormDetail = /** @class */ (() => {
    var _a;
    let ReviewFormDetail = class ReviewFormDetail extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.totalFormQuestionsCount = 0;
            this.completedQuestionsCount = 0;
        }
        // get reviewFormDetails() {
        //     return PAReviewModule.reviewDetail.reviewFormDetails;
        // }
        get qnaFlags() {
            const { isFormVisible, isFormReadOnly, isFormCommentsVisible, isFormCommentable, assignmentId } = this.reviewFormDetail;
            return { isFormVisible, isFormReadOnly, isFormCommentsVisible, isFormCommentable, assignmentId };
            // var newObj: qnaFlagsType = { isFormVisible: true, isFormReadOnly: false, isFormCommentsVisible: true, isFormCommentable: true };
            // return newObj;
        }
        get questionAndAnswers() {
            return this.reviewFormDetail.questionAndAnswerItems;
        }
        get completedStatusString() {
            this.totalFormQuestionsCount = this.reviewFormDetail.questionAndAnswerItems.length;
            this.completedQuestionsCount = this.reviewFormDetail.questionAndAnswerItems.filter((x) => x.answerText != null).length;
            return `${this.completedQuestionsCount}/${this.totalFormQuestionsCount}`;
        }
        get progressPercentage() {
            if (this.totalFormQuestionsCount === 0) {
                return 0;
            }
            return Math.floor((this.completedQuestionsCount / this.totalFormQuestionsCount) * 100);
        }
        get isCompleted() {
            return this.completedQuestionsCount == this.totalFormQuestionsCount;
        }
        get hasAnswer() {
            return this.reviewFormDetail.employeeName != "";
        }
    };
    __decorate([
        Prop(),
        __metadata("design:type", typeof (_a = typeof IPAReviewFormDetailItemDTO !== "undefined" && IPAReviewFormDetailItemDTO) === "function" ? _a : Object)
    ], ReviewFormDetail.prototype, "reviewFormDetail", void 0);
    ReviewFormDetail = __decorate([
        Component({
            name: "ReviewFormDetail",
            components: {
                Loader,
                simplebar,
                QuestionAndAnswerComponent,
            },
        })
    ], ReviewFormDetail);
    return ReviewFormDetail;
})();
export default ReviewFormDetail;
